import { call, put, delay } from "redux-saga/effects";
import { initializeAppAction } from "../initializeApp/action";

function checkInternet() {
    return navigator.onLine;
}

export function* systemResumeSaga() {
    try {
        console.log('System resume started')
        // Initial delay
        yield delay(2000);

        // Wait for internet
        while (!(yield call(checkInternet))) {
            console.log('Waiting for internet connection...');
            yield delay(2000);
        }
        
        console.log('Internet available, initializing app');
        yield put(initializeAppAction());
        console.log('System resume completed');

    } catch (error) {
        console.error('System resume failed:', error);
    }
}
